import { render, staticRenderFns } from "./default_no_footer.vue?vue&type=template&id=4319f6bc&scoped=true&lang=pug&"
import script from "./default_no_footer.vue?vue&type=script&lang=js&"
export * from "./default_no_footer.vue?vue&type=script&lang=js&"
import style0 from "./default_no_footer.vue?vue&type=style&index=0&id=4319f6bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4319f6bc",
  null
  
)

export default component.exports